import {
  BusinessGroup,
  SearchMode,
  SearchQueryStringParams,
  SearchType,
} from 'components/search/utils';
import { assertNever } from '@tock/shared/utils/typeUtils';
import { buildQueryTypeForCity } from 'routes/www/availability-search/buildQueryTypeForCity';
import { core } from '@tock/coretypes';
import { match, useRouteMatch } from 'react-router-dom';
import { useBusinessGroup } from 'hooks/useBusinessGroups';
import { useCurrentMetroArea } from 'hooks/useCurrentMetroArea';
import { useDeepMemo } from 'hooks/useDeepMemo';
import { useQueryStringParams } from 'hooks/useQueryStringParams';

/**
 * builds and memo's a search mode that is
 * used by various components to know what adjustments to
 * make in search results. is available on search handler context
 * @param {SearchType} type
 */
export function useSearchMode(type: SearchType) {
  const queryStringParams = useQueryStringParams<SearchQueryStringParams>();
  const match = useRouteMatch<{ groupSlug?: string; citySlug?: string }>();
  const currentMetroArea = useCurrentMetroArea();
  const groupSlug = match?.params?.groupSlug;
  const businessGroup = useBusinessGroup(groupSlug);
  const mode: SearchMode | undefined = useDeepMemo(
    () => buildMode(type, currentMetroArea, queryStringParams, match, businessGroup),
    [currentMetroArea, groupSlug, queryStringParams, type, businessGroup]
  );
  return mode;
}
export function buildMode(
  type: SearchType,
  currentMetroArea: core.MetroArea | undefined,
  queryStringParams: SearchQueryStringParams & Dictionary<string>,
  match: match<{
    groupSlug?: string | undefined;
    citySlug?: string | undefined;
  }>,
  businessGroup?: BusinessGroup
): SearchMode | undefined {
  let searchMode;
  switch (type) {
    case 'collectionPage':
    case 'city':
      searchMode = {
        stateType: type,
        metroArea: currentMetroArea as core.MetroArea,
        queryType: buildQueryTypeForCity(queryStringParams),
      };
      break;

    case 'group': {
      if (businessGroup?.id) {
        searchMode = {
          stateType: type,
          businessGroup,
        };
      }
      break;
    }

    case 'togo':
      searchMode = {
        stateType: type,
      };
      break;

    default:
      assertNever(type);
  }
  return searchMode;
}
